'use strict';

cartSellerProduct.$inject = ["common", "textBuilder", "CartErrorMessage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartSellerProduct = cartSellerProduct;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartSellerProduct(common, textBuilder, CartErrorMessage) {
    var clazz = function CartSellerProduct() {
        var defaults = {
            id: 0,
            type: '',
            image: '',
            name: '',
            discountName: '',
            discountImagePath: '',
            displayName: '',
            displayImage: '',
            description: '',
            productNumber: '',
            promocode: '',
            discountId: 0,
            discountType: '',
            quantity: 0,
            initialQuantity: 0,
            unitPrice: 0,
            unitPriceWithDiscount: 0,
            discountPct: 0,
            discountAmount: 0,
            vatPct: 0,
            vatAmount: 0,
            totalPriceWithDiscount: 0,
            totalPrice: 0,
            discountRanges: null,
            daysLeftUntilDiscountExpires: 0,
            included_products: [],
            grossProfitPercentage: 0,
            grossProfitPercentageWithoutDiscount: 0,
            grossProfitAmount: 0,
            errorMessages: null,
            // calculated fields
            quantityToAddForHighestDiscount: 0,
            productNumberAndPromo: '',
            isDisabled: false,
            createdOn: null,
            lowestDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, product) {
            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerInUpdatedCart) {
                return;
            }

            var productInUpdatedCart = _lodash2.default.find(sellerInUpdatedCart.products, function (p) {
                return p.id === product.id && p.discountId === product.discountId;
            });
            if (!productInUpdatedCart) {
                return;
            }

            this.unitPriceWithDiscount = productInUpdatedCart.unitPriceWithDiscount;
            this.totalPriceWithDiscount = productInUpdatedCart.totalPriceWithDiscount;
            this.discountPct = productInUpdatedCart.discountPct;
            this.discountAmount = productInUpdatedCart.discountAmount;
            this.totalPrice = this.totalPriceWithDiscount + this.discountAmount;

            // Also set quantityToAddForHighestDiscount and highestDiscount
            this.highestDiscount = this.getHighestDiscount();
            this.quantityToAddForHighestDiscount = this.getQuantityToAddForHighestDiscount();
            this.initialQuantity = this.quantity;

            this.errorMessages = productInUpdatedCart.errorMessages;
        },

        getLowestDiscount: function getLowestDiscount() {
            if (!this.discountRanges || this.discountRanges.length <= 0) {
                return null;
            }

            return this.discountRanges[this.discountRanges.length - 1];
        },

        getHighestDiscount: function getHighestDiscount() {
            if (!this.discountRanges || this.discountRanges.length <= 0) {
                return null;
            }

            return this.discountRanges[0];
        },

        getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
            var highestDiscount = this.getHighestDiscount();
            if (!highestDiscount) {
                return;
            }

            return highestDiscount.from > this.quantity ? highestDiscount.from - this.quantity : 0;
        },

        removeMessage: function removeMessage(id) {
            _lodash2.default.remove(this.errorMessages, { id: id });
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.productId;
        o.type = common.serverTypes.getProductType(resource.productTypeCode);
        o.image = resource.productImagePath;
        o.name = resource.name;
        o.discountName = resource.discountName;
        o.discountImagePath = resource.discountImagePath;
        o.description = resource.description;
        o.productNumber = resource.productNumber;
        o.promocode = resource.promocode;
        o.discountId = resource.discountId;
        o.discountType = resource.discountType;
        o.quantity = resource.quantity;
        o.initialQuantity = o.quantity;
        o.portalContractTypeCode = resource.portalContractTypeCode;
        o.unitPrice = resource.unitPrice;
        o.unitPriceWithDiscount = resource.unitPriceWithDiscount;
        o.discountPct = resource.discountPct;
        o.discountAmount = resource.discountAmount;
        o.vatPct = resource.tax ? resource.tax.taxPercentage : 0;
        o.vatAmount = resource.tax ? resource.tax.amount : 0;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalPrice = o.totalPriceWithDiscount + o.discountAmount;
        o.discountRanges = _lodash2.default.map(resource.discountRanges, function (i) {
            return { from: i.from, discount: i.discount, symbol: i.discountValueTypeSymbol };
        });
        o.daysLeftUntilDiscountExpires = resource.daysLeftUntilDiscountExpires;
        o.createdOn = resource.createdOn;
        o.maxDiscount = resource.maxDiscount;
        o.isExpired = resource.isExpired;
        o.totalPriceDiscount = resource.totalPriceDiscount;
        o.totalPriceDiscountPct = resource.totalPriceDiscountPct;
        o.totalPriceDiscountId = resource.totalPriceDiscountId;
        o.retroactive = resource.retroactive;
        o.allowSpecial = resource.allowSpecial;
        o.grossProfitAmount = resource.grossProfitAmount;

        if (resource.panaceeContent && resource.panaceeContent.length > 0) {
            o.included_products = _lodash2.default.map(resource.panaceeContent, function (i) {
                return {
                    id: i.productId,
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.productNumber
                };
            });
        }

        if (resource.promoPackContent && resource.promoPackContent.length > 0) {
            o.included_products = _lodash2.default.map(resource.promoPackContent, function (i) {
                return {
                    id: i.productId,
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.productNumber
                };
            });
        }

        o.lowestDiscount = o.getLowestDiscount();
        o.highestDiscount = o.getHighestDiscount();
        o.quantityToAddForHighestDiscount = o.getQuantityToAddForHighestDiscount();
        o.productNumberAndPromo = textBuilder.getProductNumberAndPromo(o.productNumber, o.promocode);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.isDisabled = _lodash2.default.some(o.errorMessages, function (i) {
            return i.isProductDisabled;
        });
        o.displayName = o.discountType === 'PANACEE' || o.discountType === 'PORTALPRODUCT' ? o.name : o.discountName || o.name;
        o.displayImage = o.discountImagePath || o.image;
        o.grossProfitPercentage = (resource.grossProfitPercentage * 100).toFixed(0);
        o.grossProfitPercentageWithoutDiscount = (resource.grossProfitPercentageWithoutDiscount * 100).toFixed(0);
        o.totalPriceDiscountPromoCode = resource.totalPriceDiscountPromoCode;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = resource.type;
        o.image = resource.image;
        o.name = resource.name;
        o.discountName = resource.discountName;
        o.discountImagePath = resource.discountImagePath;
        o.description = resource.description;
        o.productNumber = resource.productNumber;
        o.promocode = resource.promocode;
        o.productNumberAndPromo = resource.productNumberAndPromo;
        o.discountId = resource.discountId;
        o.quantity = resource.quantity;
        o.initialQuantity = o.quantity;
        o.unitPrice = resource.unitPrice;
        o.unitPriceWithDiscount = resource.unitPriceWithDiscount;
        o.discountPct = resource.discountPct;
        o.discountAmount = resource.discountAmount;
        o.vatPct = resource.vatPct;
        o.vatAmount = resource.vatAmount;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalPrice = resource.totalPrice;
        o.discountRanges = resource.discountRanges;
        o.daysLeftUntilDiscountExpires = resource.daysLeftUntilDiscountExpires;
        o.included_products = resource.included_products;
        o.createdOn = resource.createdOn;
        o.maxDiscount = resource.maxDiscount;
        o.portalContractTypeCode = resource.portalContractTypeCode;
        o.allowSpecial = resource.allowSpecial;
        o.lowestDiscount = o.getLowestDiscount();
        o.highestDiscount = o.getHighestDiscount();
        o.quantityToAddForHighestDiscount = o.getQuantityToAddForHighestDiscount();
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.createFromLocalStorage(i);
        });
        o.isDisabled = resource.isDisabled;
        o.displayName = o.discountName || o.name;
        o.displayImage = o.discountImagePath || o.image;

        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartSellerProductModel.js
// module id = 736
// module chunks = 0